// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveParticipationIdentitySubmissionAllowDuplicates } from '../models/ApiWaveParticipationIdentitySubmissionAllowDuplicates';
import { ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted } from '../models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted';
import { HttpFile } from '../http/http';

export class ApiWaveParticipationSubmissionStrategyIdentityConf {
    'duplicates': ApiWaveParticipationIdentitySubmissionAllowDuplicates;
    'who_can_be_submitted': ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "duplicates",
            "baseName": "duplicates",
            "type": "ApiWaveParticipationIdentitySubmissionAllowDuplicates",
            "format": ""
        },
        {
            "name": "who_can_be_submitted",
            "baseName": "who_can_be_submitted",
            "type": "ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveParticipationSubmissionStrategyIdentityConf.attributeTypeMap;
    }

    public constructor() {
    }
}


